import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-75229a2b"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "page-container"
};
var _hoisted_2 = {
  class: "item-detail-list"
};
var _hoisted_3 = {
  class: "page-inner-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ItemDetailBanner = _resolveComponent("ItemDetailBanner");
  var _component_ItemDetailNavBar = _resolveComponent("ItemDetailNavBar");
  var _component_ItemDetailBox = _resolveComponent("ItemDetailBox");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.itemService.item && _ctx.itemService.item.contestNavigationBarRespList ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createVNode(_component_ItemDetailBanner), _createElementVNode("div", _hoisted_2, [_createVNode(_component_ItemDetailNavBar, {
    list: _ctx.itemService.item.contestNavigationBarRespList
  }, null, 8, ["list"]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemService.itemList, function (item, index) {
    return _openBlock(), _createBlock(_component_ItemDetailBox, {
      key: index,
      title: item.navBarName,
      desc: item.navBarText
    }, null, 8, ["title", "desc"]);
  }), 128))])])], 64)) : _createCommentVNode("", true)]);
}